/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { selectSubcategory as selectSubcategoryMutator } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
export default orchestratorAction('selectSubcategory', function hideFullOptions(subcategory) {
    var continueAfterConfirmCallback = function () {
        selectSubcategoryMutator(subcategory);
    };
    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectSubcategory.js.map